import React from "react";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import TipoEntrega from "./helpers/TipoEntrega";
import ContentTable from "./ContentTable";
import { getCostString, getTimeDiff, getTimeStr, getTimeWithHourStr } from "./helpers";
import { getRowsAndTotal } from "../../state/order/actions";
import { getListOrigens, getLabelOrigem } from "../../main/origem";
import consts from "../../main/consts";
import { salesChannelIsAmericanas } from "../../utils/check-sales-channel";

const styles = (theme) => ({
  totalCost: {
    minWidth: 130,
    fontWeight: "bold",
  },
  maxWidthCol: {
    maxWidth: 170,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "inherit",
    },
  },
  duracao: {
    textTransform: "lowercase",
  },
  capitalize: {
    textTransform: "capitalize",
  },
});

const getHeaders = (classes) => [
  {
    title: "Nº Pedido",
    align: "left",
    dataField: "codigoExterno",
    class: classes.maxWidthCol,
  },
  {
    title: "Origem",
    align: "left",
    dataField: "origem",
    filter: "origem",
    filterOptions: getListOrigens(),
    render: (data) => getLabelOrigem(data),
  },
  {
    title: "Data",
    align: "left",
    dataField: "dataInclusao",
    render: (data) => new Date(data).toLocaleDateString(),
  },
  {
    title: "Entrega estimada",
    align: "left",
    dataField: "dhEntregaEstimada",
    render: (data, row) => salesChannelIsAmericanas(row.canalDeVendas) ? getTimeStr(data) : getTimeWithHourStr(data),
  },
  {
    title: "Duração",
    align: "left",
    dataField: "dataInclusao",
    class: classes.duracao,
    render: (data) => (
      <Tooltip title="Tempo desde a chegada do pedido">
        <span>{getTimeDiff(data)}</span>
      </Tooltip>
    ),
  },
  {
    title: "Cliente",
    align: "left",
    dataField: "cliente",
    class: classes.capitalize,
    render: (data) => data && data.nome.toLowerCase(),
  },
  {
    title: "Canal de venda",
    align: "left",
    dataField: "canalDeVendas",
    render: (data) => data,
  },
  {
    title: "Associado",
    align: "left",
    dataField: "associado",
    class: classes.capitalize,
    render: (data) => data && data.nome.toLowerCase(),
  },
  {
    title: "Tipo de Entrega",
    align: "left",
    dataField: "tipoEntrega",
    render: (data) => <TipoEntrega tipoEntrega={data} />,
  },
  {
    title: "Total",
    align: "right",
    dataField: "valorTotal",
    class: classes.totalCost,
    render: getCostString,
  },
];

const PAGE_NAME = "shipping";
const ROWS_PER_PAGE = consts.ROWS_PER_PAGE;
class SaiuEntrega extends React.Component {
  componentDidMount() {
    this.loadGridData(0, ROWS_PER_PAGE, true);
  }

  componentDidUpdate(prevProps) {
    const {
      loja,
      orders: { filters },
      limit,
    } = this.props;

    if (
      loja !== prevProps.loja ||
      filters !== prevProps.orders.filters ||
      prevProps.limit !== limit
    ) {
      this.loadGridData(0, ROWS_PER_PAGE, true);
    }
  }

  loadGridData = (page, limits, avoidSpinner = false) => {
    const {
      getRowsAndTotal,
      orders: { filters },
      limit,
    } = this.props;
    limits = limits || ROWS_PER_PAGE;

    getRowsAndTotal({
      page,
      limit: limit,
      filters: { ...filters, status: "SAIU_PARA_ENTREGA" },
      avoidSpinner,
      pageId: PAGE_NAME,
    });
  };

  clickRow = (row) => {
    this.props.history.push(`${consts.CONTEXT}/shipping/${row.numero}`, {
      data: { page: PAGE_NAME },
    });
  };

  render() {
    return (
      <ContentTable
        loaded={this.props.orders.loaded}
        limit={this.props.limit}
        title="Saiu para Entrega"
        subtitle="Saiba onde o entregador está em tempo real. Algumas não são rastreáveis."
        page={PAGE_NAME}
        headers={getHeaders(this.props.classes)}
        onClickRow={this.clickRow}
        rows={this.props.orders.grids[PAGE_NAME].rows}
        total={this.props.orders.grids[PAGE_NAME].total}
        selectedPage={this.props.orders.page}
        rowsPerPage={ROWS_PER_PAGE}
        showPaginator={false}
        onHandlePageChange={this.loadGridData}
        selectedOrigemFilter={getLabelOrigem(
          this.props.orders.grids[PAGE_NAME].selectedFilter
        )}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    loja: state.auth.loja,
    limit: state.orders.limit,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getRowsAndTotal }, dispatch);
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(SaiuEntrega);
